import {forwardRef} from 'react';
import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import MenuIcon from '@heroicons/react/solid/MenuIcon';

const SectionHandle = SortableHandle(({label}) => <span role="button" tabIndex={0}
    aria-label={`Reorder ${label || 'Section'}`} title="Press Space, use the arrow keys to move, then press Space again."
    className="inline-flex shrink-0 cursor-move rounded p-1 text-panels-700 focus:outline-none focus:ring-2">
    <MenuIcon className="h-5 w-5" aria-hidden="true"/>
</span>);

const Section = SortableElement(({fieldset, children}) => <div className="flex items-start gap-2">
    <SectionHandle label={fieldset.label}/>
    <div className="flex-1 min-w-0">{children}</div>
</div>);

export const FieldsetItem = ({enabled, fieldset, index, children}) => enabled
    ? <Section index={index} collection="sections" fieldset={fieldset}
               disabled={fieldset.system || !fieldset.id || fieldset.editing}>{children}</Section>
    : children;

const Sections = SortableContainer(({containerRef, className, children}) =>
    <div ref={containerRef} className={className}>{children}</div>);

export const FieldsetContainer = forwardRef(({enabled, className, children, onSortEnd}, ref) => enabled
    ? <Sections containerRef={ref} className={className} useDragHandle helperClass="sort-helper"
                onSortStart={() => {
                    const helper = document.querySelector('.sort-helper');
                    if (helper) helper.style.zIndex = 50000;
                }} onSortEnd={onSortEnd}>{children}</Sections>
    : <div ref={ref} className={className}>{children}</div>);
